import { createAction } from '@reduxjs/toolkit';
import { VerifyEmailPayload } from 'features/admin-email-verification/api/types';

export const emailVerificationActions = {
  resetState: createAction('[email_verification]RESET_STATE'),
  verifyEmailRequest: createAction<VerifyEmailPayload>(
    '[email_verification]VERIFY_EMAIL_REQUEST'
  ),
  verifyEmailSuccess: createAction('[email_verification]VERIFY_EMAIL_SUCCESS'),
  verifyEmailFailure: createAction<string>(
    '[email_verification]VERIFY_EMAIL_FAILURE'
  ),

  sendEmailVerificationTokenRequest: createAction(
    '[email_verification]SEND_EMAIL_VERIFICATION_TOKEN_REQUEST'
  ),
  sendEmailVerificationTokenSuccess: createAction(
    '[email_verification]SEND_EMAIL_VERIFICATION_TOKEN_SUCCESS'
  ),
  sendEmailVerificationTokenFailure: createAction(
    '[email_verification]SEND_EMAIL_VERIFICATION_TOKEN_FAILURE'
  ),
};
